import React from 'react';

export function Page404(props){

    return (
        <div>
            <h2>404 page</h2>
        </div>
    );
}